import api from '@/shared/api';

export const getBillingInformation = (legalAdId, legalAd) => {
  // For all legal ads of type "transfert", we need to set the type to "transfert-siege" in the API request
  if (legalAd.model?.type?.includes("transfert")) {
    legalAd.model.type = "transfert-siege";
  }

  const attributes = {
    id: legalAdId,
    newspaperId: legalAd.newspaperId,
    format: legalAd.format,
    content: { ...legalAd.content },
    model: { type: legalAd.model?.type },
    base64Logo: legalAd.content.logo?.data,
  };

  delete attributes.content.logo;

  return api.post('/estimations', { legalAd: attributes }).then(({ data }) => data);
};
export const create = legalAd => {
  // For all legal ads of type "transfert", we need to set the type to "transfert-siege" in the API request
  if (legalAd.model?.type?.includes("transfert")) {
    legalAd.model.type = "transfert-siege";
  }

  const attributes = { ...legalAd, content: { ...legalAd.content }, base64Logo: legalAd.content.logo?.data };

  delete(attributes.content.logo);
  if (attributes.publishingAt) {
    const date = attributes.publishingAt;
    attributes.publishingAt = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
  }

  return api.post('/orders', { legalAd: attributes, draftId: legalAd.id }).then(({ data }) => data);
};

export const update = (paymentIntentId, addressAttributes = {}) => {
  return api.put(`/orders/${paymentIntentId}`, { paymentIntentId, addressAttributes }).then(({ data }) => data);
};
